import React from "react";
import "./Footer.scss";

const Footer = () => {
  return <div></div>;
};

export default Footer;
